// extracted by mini-css-extract-plugin
export var container = "_e9-0";
export var icon = "_e9-1";
export var text = "_e9-2";